import { useState, useEffect } from 'react'
import gql from 'graphql-tag'
import { useSubscription } from '@apollo/client'

const mediaUpdatedSubscription = gql`
  subscription($id: String!) {
    mediaUpdated(mediaId: $id) {
      id
      updatedBy {
        id
        firstName
        lastName

        user {
          id
        }
      }
    }
  }
`

// TODO: Dig into Apollo to see if there is a way around the initialSkip hack.
const useMediaUpdatedSubscription = (id: string | undefined | null, onData) => {
  const [initialSkip, setInitialSkip] = useState(true)
  useEffect(() => {
    requestAnimationFrame(() => {
      setInitialSkip(false)
    })
  }, [])

  useSubscription(mediaUpdatedSubscription, {
    variables: { id },
    skip: !id || initialSkip,
    fetchPolicy: 'no-cache',
    onData
  })
}

export default useMediaUpdatedSubscription
